import { render, staticRenderFns } from "./InteriorBandPhoto.vue?vue&type=template&id=ff5bfbba&"
import script from "./InteriorBandPhoto.vue?vue&type=script&lang=js&"
export * from "./InteriorBandPhoto.vue?vue&type=script&lang=js&"
import style0 from "./InteriorBandPhoto.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VThemeProvider } from 'vuetify/lib/components/VThemeProvider';
installComponents(component, {VCard,VCol,VContainer,VImg,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VRow,VThemeProvider})
